import { Vision } from '@tencent/vision'

const vision = new Vision({
  appId: 1
})
window.vision = vision;

export default vision